/* eslint-disable security/detect-object-injection */
/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBuyboxAddToCartViewProps, IBuyboxAddToOrderTemplateViewProps, IBuyboxAddToWishlistViewProps, IBuyboxKeyInPriceViewProps, IBuyboxProductConfigureDropdownViewProps, IBuyboxProductConfigureViewProps, IBuyboxProductQuantityViewProps, IBuyboxShopSimilarLookViewProps } from './components/c-buyboxInterface';
import { IBuyboxViewProps } from './c-buybox';
import { IBuyboxFindInStoreViewProps } from './components/c-buybox-find-in-store';
import { ICBuyboxProps } from './c-buybox.props.autogenerated'

import { getInventFlagsAsync } from "../../actions/FlintFoxPDPAction.g";
import ReactHtmlParser from 'react-html-parser';

interface IAccordionData {
    details: number;
    care: number;
    size: number;
    fabrics: number;
    CareDescription: string;
    FabricsDescription: string;
    FitAndSizeDescription: string;
}

const BuyboxView: React.FC<IBuyboxViewProps> = props => {
    // const { ModuleProps, MediaGalleryContainerProps, ProductInfoContainerProps, addToCart, addToOrderTemplate, addToWishlist, configure, description, findInStore, quantity, price, title, inventoryLabel, FLook, keyInPrice,
    //     shopSimilarDescription } = props;
    const { ModuleProps, MediaGalleryContainerProps, ProductInfoContainerProps, addToCart, addToOrderTemplate, addToWishlist, configure, description, findInStore, quantity, price, title, shopSimilarLook, keyInPrice,
        shopSimilarDescription } = props;

    const [accordiansData, setAccordiansData] = React.useState<IAccordionData>({
        details: 0,
        care: 0,
        size: 0,
        fabrics: 0,
        CareDescription: "",
        FabricsDescription: "",
        FitAndSizeDescription: ""
    })

    React.useEffect(() => {
        try {
            _getInventFlagsAsyncTemp(props).then((response: any) => {
                if (response && response[0] !== undefined) {
                    setAccordiansData(response[0])
                }

            })


        } catch (error) {
            console.log(error);
        }

        const url = window.location.href;
        const script = document.createElement('script');
        url.indexOf("dynamics.com/uk") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnectionuk/main_site/staging/en_GB/bv.js"
            : url.indexOf("dynamics.com/de") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnectionde/main_site/staging/de_DE/bv.js"
                : url.indexOf("peruvianconnection.com") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnection/main_site/production/en_US/bv.js"
                    : url.indexOf("peruvianconnection.co.uk") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnectionuk/main_site/production/en_GB/bv.js"
                        : url.indexOf("peruvianconnection.de") > -1 ? script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnectionde/main_site/production/de_DE/bv.js"
                            : script.src = "https://apps.bazaarvoice.com/deployments/peruvianconnection/main_site/staging/en_US/bv.js"
        script.async = true;
        document.getElementsByClassName("ms-buybox__content")[0].appendChild(script);
        return () => {
            document.getElementsByClassName("ms-buybox__content")[0].removeChild(script);
        }

    }, [])


    return (
        <Module {...ModuleProps}>
            <Node {...MediaGalleryContainerProps}>
                {props.mediaGallery}
            </Node>
            <Node {...ProductInfoContainerProps}>
                {title}
                {price}
                {_renderBVRatingSummary(props)}
                {/* {unitOfMeasure} */}
                {/* {description} */}
                {/* {rating} */}
                {configure && _renderConfigure(configure)}
                {keyInPrice && _renderKeyInPrice(keyInPrice)}
                {quantity && _renderQuantity(quantity)}
                {/* {inventoryLabel} */}
                {/* {addToCart && _renderAddToCart(addToCart)} */}
                {addToCart && addToWishlist && _renderAddToCartWithWishList(props, addToCart, addToWishlist)}
                {findInStore && _renderFindInStore(findInStore)}
                {addToOrderTemplate && _renderAddToOrderTemplate(addToOrderTemplate)}
                {/* {addToWishlist && _renderAddToWishlist(addToWishlist)} */}
                {_renderSocialShare(props.slots && props.slots.socialShare)}
                {props && _renderAccordion(props, accordiansData, description)}
                {shopSimilarLook && _renderShopSimilarItem(shopSimilarLook)}
                {shopSimilarDescription && _renderShopSimilarItem(shopSimilarDescription)}
            </Node>
        </Module>
    );
};

const _getInventFlagsAsyncTemp = async (props: IBuyboxViewProps & ICBuyboxProps<{}>) => {

    try {
        return await getInventFlagsAsync(
            { callerContext: props.context.actionContext },
            `${props.data.product.result?.ItemId}`
        ).catch(err => {
            console.log(err);
        })
            .then(Value => {
                if (Value) {
                    return Value
                }
                return Value
            });
    }
    catch (error) {
        return ''
    }
};

const _renderAccordion = (props: IBuyboxViewProps & ICBuyboxProps<{}>, accData: IAccordionData, custDesc: any): JSX.Element => {

    const [activeAccordion, setActiveAccordion] = React.useState('');

    const replaceAnchorTags = (text: React.ReactElement<any, string | React.JSXElementConstructor<any>>[]) => {

        for (let i = 0; i < text.length; i++) {
            if (text[i].type === "a") {
                if (text[i].props.className === "cus-link-care") {
                    text[i] = <p className="cus-link" onClick={() => setActiveAccordion("care")}>{text[i].props.children}</p>;
                }
                else if (text[i].props.className === "cus-link-details") {
                    text[i] = <p className="cus-link" onClick={() => setActiveAccordion("details")}>{text[i].props.children}</p>;
                }
                else if (text[i].props.className === "cus-link-size") {
                    text[i] = <p className="cus-link" onClick={() => setActiveAccordion("size")}>{text[i].props.children}</p>;
                }
                else {
                    text[i] = <p className="cus-link" onClick={() => setActiveAccordion("about")}>{text[i].props.children}</p>;
                }
            }
        }

    }

    if (accData.details === 1 || accData.size === 1 || accData.care || accData.fabrics === 1) {

        const details = custDesc?.props.children;
        const detailDesc = ReactHtmlParser(details);
        replaceAnchorTags(detailDesc);

        const about = accData.FabricsDescription;
        const aboutDesc = ReactHtmlParser(about);
        replaceAnchorTags(aboutDesc);


        const care = accData.CareDescription;
        const careDesc = ReactHtmlParser(care);
        replaceAnchorTags(careDesc);

        const sizeDesc = accData.FitAndSizeDescription;
        const fitAndSizeDesc = ReactHtmlParser(sizeDesc);
        replaceAnchorTags(fitAndSizeDesc);

        return (
            <div className="cust-accordion">
                {accData.details === 1 &&
                    <div className="ms-refine-submenu list-group Category">
                        <button onClick={() => activeAccordion === "" ? setActiveAccordion("details") : setActiveAccordion("")}
                            type="button"
                            className="ms-refine-submenu__toggle_expanded msc-btn accordion-btn"
                        >{props.resources.accordionDetailsText} <span>{activeAccordion === "details" ? "+" : "-"}</span>
                        </button>
                        <div className={`show ${activeAccordion === "" ? "collapse" : "no-show-pc"}`}>
                            {detailDesc}
                        </div>
                    </div>
                }
                {accData.size === 1 &&
                    <div className="ms-refine-submenu list-group Rating">
                        <button onClick={() => activeAccordion === "size" ? setActiveAccordion("") : setActiveAccordion("size")}
                            type="button"
                            className="ms-refine-submenu__toggle_expanded msc-btn accordion-btn"
                        >{props.resources.accordionSizeAndFitText} <span>{activeAccordion === "size" ? "-" : "+"}</span>
                        </button>
                        <div className={`collapse ${activeAccordion === "size" ? "show" : ""}`} >
                            {fitAndSizeDesc}
                        </div>
                    </div>
                }
                {accData.care === 1 &&
                    <div className="ms-refine-submenu list-group Color">
                        <button onClick={() => activeAccordion === "care" ? setActiveAccordion("") : setActiveAccordion("care")}
                            type="button"
                            className="ms-refine-submenu__toggle_expanded msc-btn accordion-btn"
                        >{props.resources.accordionCareText} <span>{activeAccordion === "care" ? "-" : "+"}</span>
                        </button>
                        <div className={`collapse ${activeAccordion === "care" ? "show" : ""}`} id="care">
                            {careDesc}
                        </div>
                    </div>}
                {accData.fabrics === 1 &&
                    <div className="ms-refine-submenu list-group Size">
                        <button onClick={() => activeAccordion === "about" ? setActiveAccordion("") : setActiveAccordion("about")}
                            type="button"
                            className="ms-refine-submenu__toggle_expanded msc-btn accordion-btn"
                        >{props.resources.accordionAboutOurFibricsText} <span>{activeAccordion === "about" ? "-" : "+"}</span>
                        </button>
                        <div className={`collapse ${activeAccordion === "about" ? "show" : ""}`} >
                            {aboutDesc}
                        </div>
                    </div>}
            </div>
        );

    } else {
        return <div></div>
    }
}

const _renderAddToCart = (addToCart: IBuyboxAddToCartViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToCart;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderAddToOrderTemplate = (addToOrderTemplate: IBuyboxAddToOrderTemplateViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToOrderTemplate;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderAddToWishlist = (addToWishlist: IBuyboxAddToWishlistViewProps): JSX.Element => {
    const { ContainerProps, errorBlock, button } = addToWishlist;

    return (
        <Node {...ContainerProps}>
            {errorBlock}
            {button}
        </Node>
    );
};

const _renderAddToCartWithWishList = (props: ICBuyboxProps<{}>, addToCart: IBuyboxAddToCartViewProps, addToWishlist: IBuyboxAddToWishlistViewProps): JSX.Element => {
    const { errorBlock } = addToCart;

    return (
        <div>
            {errorBlock}
            <div className="ms-buybox product-add-to-cart">
                <div className="buttons ">
                    <div className="cust-add-to-bag">
                        {_renderAddToCart(addToCart)}
                    </div>
                    <div className="cust-add-to-wishlist-pc">
                        {_renderAddToWishlist(addToWishlist)}
                        <div className="add-to-wishlist-text">{props.resources.addToWishListBuyboxText}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}

const _renderConfigure = (configure: IBuyboxProductConfigureViewProps): JSX.Element => {
    const { ContainerProps, dropdowns, messageBox } = configure;

    return (
        <Node {...ContainerProps}>
            {dropdowns.map(_renderConfigureDropdown)}
            {messageBox}
        </Node>
    );
};

const _renderSocialShare = (socialShare: React.ReactNode[]): JSX.Element | undefined => {
    if (!socialShare || socialShare.length === 0) {
        return undefined;
    }

    return (
        <>
            {socialShare[0]}
        </>
    );
};

const _renderConfigureDropdown = (dropdown: IBuyboxProductConfigureDropdownViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, errors, select } = dropdown;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {select}
        </Node>
    );
};

const _renderFindInStore = (findInStore: IBuyboxFindInStoreViewProps): JSX.Element => {
    const { ContainerProps, storeSelector, heading, description, errors, button, modal, productPickupOptionList } = findInStore;

    return (
        <Node {...ContainerProps}>
            {storeSelector}
            {heading}
            {productPickupOptionList}
            {description}
            {errors}
            {button}
            {modal}
        </Node>
    );
};

const _renderQuantity = (quantity: IBuyboxProductQuantityViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input, errors } = quantity;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
                {errors}
            </Node>
            {input}
        </Node>
    );
};

const _renderKeyInPrice = (keyInPrice: IBuyboxKeyInPriceViewProps): JSX.Element => {
    const { ContainerProps, LabelContainerProps, heading, input } = keyInPrice;

    return (
        <Node {...ContainerProps}>
            <Node {...LabelContainerProps}>
                {heading}
            </Node>
            {input}
        </Node>
    );
};

const _renderShopSimilarItem = (shopSimilarItem: IBuyboxShopSimilarLookViewProps): JSX.Element => {
    const { ContainerProps, errors, input } = shopSimilarItem;

    return (
        <Node {...ContainerProps}>
            {errors}
            {input}
        </Node>
    );
};

const _renderBVRatingSummary = (props: IBuyboxViewProps & ICBuyboxProps<{}>) => {

    return (
        <div className="bv-rating_summary" data-bv-product-id={props.data.product.result?.ItemId} data-bv-show="rating_summary"></div>
    );
}

export default BuyboxView;
